import './ui/styles.css';
import { mountApp } from './ui/app';

mountApp(document.getElementById('app')!);
